import { workflowOfferEn } from './workflow-offer.en';
import { workflowOfferEs } from './workflow-offer.es';

const offers = { en: workflowOfferEn, es: workflowOfferEs };
export const getWorkflowOffer = lang => offers[lang];